"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10 10.913C8.343 10.913 7 9.57 7 7.913C7 6.256 8.343 4.913 10 4.913C11.657 4.913 13 6.256 13 7.913C13 9.57 11.657 10.913 10 10.913ZM10 2C6.687 2 4 4.658 4 7.935C4 10.713 8.308 16.313 9.624 17.828C9.823 18.058 10.177 18.058 10.376 17.828C11.692 16.313 16 10.713 16 7.935C16 4.658 13.313 2 10 2Z",
    fill: "#727B7F"
  }));
};